/* eslint-disable */
function getGoogleTagConsent(cookiePreferences) {
  const consent = {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
  };

  if (cookiePreferences.advertising) {
    consent.ad_storage = 'granted';
    consent.ad_user_data = 'granted';
    consent.ad_personalization = 'granted';
  }

  if (cookiePreferences.marketingAndAnalytics) {
    consent.analytics_storage = 'granted';
  }

  return consent;
}

const googleTagId = process.env.GOOGLE_TAG_IDAGIO_WEBSITE_ALL_COUNTRIES_ID;

export const googleTagSrc = `https://www.googletagmanager.com/gtag/js?id=${googleTagId}`;

export const googleTagScript = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${googleTagId}');
`;

export const googleTagConsentScript = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}

    gtag('consent', 'default', ${JSON.stringify(getGoogleTagConsent({}))});
`;

export function updateGoogleTagConsent(cookiePreferences) {
  function gtag() {
    window.dataLayer.push(arguments);
  }

  gtag('consent', 'update', getGoogleTagConsent(cookiePreferences));
}

export function loadGtmContainer(containerId) {
  if (typeof document === 'undefined' || !containerId) {
    return;
  }

  window.__loadedGtmContainers = window.__loadedGtmContainers || {};
  if (window.__loadedGtmContainers[containerId]) {
    return;
  }
  window.__loadedGtmContainers[containerId] = true;

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), 'event': 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', containerId);
}



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/googleTag.js